import { createCrudActions } from '../utils/crudGenerator';

const formatWorkers = (data) => {
    if (!data) {
        return [];
    }
    const formatItem = (item) => ({
        ...item,
        label: `${item.name}`,
        value: item._id,
    });

    if (Array.isArray(data)) {
        return data.map(formatItem);
    }
    return formatItem(data);
};

export const {
    fetch: fetchWorkers,
    create: createWorker,
    update: updateWorker,
    delete: deleteWorkers
} = createCrudActions('WORKER', "Trabajadore", formatWorkers);